import { connect } from 'react-redux';
import { togglePinGroup, unrecommendGroup } from '../../redux/actions';
const mapDispatchToProps = {
    togglePinGroup,
    unrecommendGroup
};
export default connect(null, mapDispatchToProps);

//# sourceMappingURL=NetworkBarGroupLink.container.js.map